import React from 'react';
import { noop } from 'lodash';

import { AttributeDefinition } from 'domain/experiment/attribute';

import { ColumnIdentifier } from './column/column-model';
import { GroupByStorageStrategy } from './group-by-model';

export enum GroupViewMode {
  Groups = 'groups',
  List = 'list',
}

export type GroupByContext = {
  isGroupByAvailable: boolean;
  storageStrategy: GroupByStorageStrategy;
  addToGroupBy: (...attrs: AttributeDefinition[]) => void;
  removeFromGroupBy: (column: ColumnIdentifier) => void;
  resetGroupBy: () => void;
  attributesInUse: AttributeDefinition[];
  reorderGroupBy: (attributes: AttributeDefinition[]) => void;
  viewMode: GroupViewMode;
  setIsGroupByEdited: React.Dispatch<React.SetStateAction<boolean>>;
  projectIdentifier: string;
};

export const GroupByContext = React.createContext<GroupByContext>({
  isGroupByAvailable: false,
  storageStrategy: {
    selector: () => undefined,
    currentQuerySelector: () => '',
    actionCreator: () => () => {},
  },
  addToGroupBy: () => undefined,
  resetGroupBy: () => undefined,
  reorderGroupBy: () => undefined,
  attributesInUse: [],
  viewMode: GroupViewMode.List,
  removeFromGroupBy: noop,
  setIsGroupByEdited: noop,
  projectIdentifier: '',
});
